import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

const { grey } = colors

type Props = {
    ...Icon,
    checked?: boolean,
    checkedColor?: string
}

const Checkbox = (props: Props) => {
    const {
        checked = false,
        color = grey,
        checkedColor = color,
        size = 24,
        className = 'checkbox',
        ...otherProps
    } = props

    return (
        <svg
            className={className}
            width={size}
            height={size}
            {...otherProps}
            xmlnsXlink="http://www.w3.org/1999/xlink"
            preserveAspectRatio="none">
            <g fillRule="evenodd">
                <path
                    d="M5.636 2A3.636 3.636 0 0 0 2 5.636v12.728A3.636 3.636 0 0 0 5.636 22h12.728A3.636 3.636 0 0 0 22 18.364V5.636A3.636 3.636 0 0 0 18.364 2H5.636zM20 18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12z"
                    fillRule="nonzero"
                    fill={color}
                />
                <path
                    d="M10.955 13.49L8 11.274a.91.91 0 1 0-1.09 1.454l4.317 3.237 6.01-7.01a.91.91 0 0 0-1.382-1.181l-4.9 5.718z"
                    fill={checkedColor}
                    fillOpacity={checked ? 1 : 0}
                />
            </g>
        </svg>
    )
}

export { Checkbox }
